import { useEffect, useRef, useState } from "react";
import { useAppContext } from "../../../context/AuthContext";
import { KeywordsController, KeywordsControllerType } from "../../../controller/keywords/KeywordsController";
import LabelsContext from "../../../lang/LabelsContext";
import KeywordsDto from "../../../model/keywords/KeywordsDto";
import MessageType from "../../../utils/MessageType";
import { handleErrorMessage, useEffectOnce } from "../../../utils/Utils";

interface KeywordsServiceType {
  keywordsList: any;
  setKeywordsList: any;
  keywordState: any;
  setKeywordState: any;
  openDialog: any;
  setOpenDialog: any;
  getKeywordsList: Function;
  addKeyword: Function;
  deleteKeyword: Function;
  updateKeyword: Function;
  searchText: any;
  setSearchText: any;
}

export default function KeywordsService(): KeywordsServiceType {
  const { axiosGetKeywordsList, axiosAddKeyword, axiosDeleteKeyword, axiosUpdateKeyword }: KeywordsControllerType =
    KeywordsController();
  const { showMessage } = useAppContext();
  const { Labels } = LabelsContext();
  const [keywordState, setKeywordState] = useState<KeywordsDto>();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [keywordsList, setKeywordsList] = useState<KeywordsDto[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const keywordsHolder = useRef<KeywordsDto[]>([]);

  useEffectOnce(() => {
    getKeywordsList();
  });

  useEffect(() => {
    let allKeywords = keywordsHolder.current;
    if (searchText) {
      allKeywords = allKeywords.filter((x: any) => {
        const wordUpperCase = x.keyword.toUpperCase();
        const searchUpperCase = searchText.toUpperCase();
        return wordUpperCase.includes(searchUpperCase);
      });
    }
    setKeywordsList(allKeywords);
  }, [searchText]);

  const getKeywordsList = () => {
    axiosGetKeywordsList()
      .then((result: any) => {
        keywordsHolder.current = result.data;
        setKeywordsList(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const addKeyword = (data: any) => {
    axiosAddKeyword(data)
      .then((result: any) => {
        showMessage(Labels.SUCCESSFULLY_ADDED, MessageType.SUCCESS);
        getKeywordsList();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const deleteKeyword = (id: string) => {
    axiosDeleteKeyword(id)
      .then((result: any) => {
        showMessage(Labels.SUCCESSFULLY_DELETED, MessageType.SUCCESS);
        getKeywordsList();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const updateKeyword = (data: any) => {
    axiosUpdateKeyword(data.id, data)
      .then((result: any) => {
        showMessage(Labels.SUCCESSFULLY_UPDATED, MessageType.SUCCESS);
        getKeywordsList();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return {
    keywordsList,
    setKeywordsList,
    keywordState,
    setKeywordState,
    openDialog,
    setOpenDialog,
    getKeywordsList,
    addKeyword,
    deleteKeyword,
    updateKeyword,
    searchText,
    setSearchText,
  };
}

export type { KeywordsServiceType };
